import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _reduce from 'lodash/reduce';
import _some from 'lodash/some';
import { createSelector } from 'reselect';
import { getInputsFromState, inputsWithErrors } from './helpers';

var getValuesFromInputs = function getValuesFromInputs(inputs) {
  return _reduce(inputs, function (acc, input, key) {
    return _objectSpread({}, acc, _defineProperty({}, key, input.value));
  }, {});
};

var areInputsValidating = function areInputsValidating(inputs) {
  return _some(inputs, function (input) {
    return input.validating;
  });
};

var areInputsPristine = function areInputsPristine(inputs) {
  return !_some(inputs, function (input) {
    return !input.pristine;
  });
};

var areInputsValid = function areInputsValid(inputs) {
  return !inputsWithErrors(inputs);
};

export var inputsSelector = function inputsSelector(inputConfig, inputKeys) {
  return function (state) {
    return getInputsFromState(inputConfig, state, inputKeys);
  };
};
export var valuesSelector = function valuesSelector(inputConfig, inputKeys) {
  return createSelector(inputsSelector(inputConfig, inputKeys), getValuesFromInputs);
};
export var validatingSelector = function validatingSelector(inputConfig, inputKeys) {
  return createSelector(inputsSelector(inputConfig, inputKeys), areInputsValidating);
};
export var pristineSelector = function pristineSelector(inputConfig, inputKeys) {
  return createSelector(inputsSelector(inputConfig, inputKeys), areInputsPristine);
};
export var validSelector = function validSelector(inputConfig, inputKeys) {
  return createSelector(inputsSelector(inputConfig, inputKeys), areInputsValid);
};
export var formSelector = function formSelector(inputConfig, inputKeys) {
  return createSelector(valuesSelector(inputConfig, inputKeys), validatingSelector(inputConfig, inputKeys), pristineSelector(inputConfig, inputKeys), validSelector(inputConfig, inputKeys), function (values, validating, pristine, valid) {
    return {
      values: values,
      validating: validating,
      pristine: pristine,
      valid: valid
    };
  });
};